import { render, staticRenderFns } from "./InternshipTalksTopics.vue?vue&type=template&id=65452063&"
import script from "./InternshipTalksTopics.vue?vue&type=script&lang=js&"
export * from "./InternshipTalksTopics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports